if (!customElements.get('product-form2')) {
  customElements.define('product-form2', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
      this.handleErrorMessage();
      this.setLoadingOnBtn(evt, true);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else if (this.closest('.product__list__sample')) {
            // Sample add from a listing/product card: keep the browsing flow.
            // Update the cart in place (icon bubble + drawer contents) but do
            // NOT open the drawer, then flash an "added" state on the button.
            this.renderCartSilently(response);
            this.flashAdded();
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.setLoadingOnBtn(evt, false);
        });
    }

    renderCartSilently(response) {
      if (!this.cart || !response || !response.sections) return;
      if ('cartItemKey' in this.cart) this.cart.cartItemKey = response.key;

      this.cart.getSectionsToRender().forEach((section) => {
        const target = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        const html = response.sections[section.id];
        if (!target || !html) return;
        target.innerHTML = this.cart.getSectionInnerHTML(html, section.selector || '.shopify-section');
      });

      this.cart.classList.remove('is-empty');

      // #CartDrawer innerHTML was just replaced, so its overlay-close handler is gone.
      const overlay = document.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof this.cart.close === 'function') {
        overlay.addEventListener('click', this.cart.close.bind(this.cart));
      }
    }

    flashAdded() {
      const btn = this.closest('.product__list__sample');
      if (!btn) return;
      btn.classList.add('is-added');
      clearTimeout(this._addedTimer);
      this._addedTimer = setTimeout(() => btn.classList.remove('is-added'), 1800);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    setLoadingOnBtn(e, show) {
        const btn = e.target.closest('.product__list__sample');
        if (!btn) {
          return;
        }
      
        const text = btn.querySelector('.btn-text');
        const spinner = btn.querySelector('.btn-spinner');
  
      if (!text || !spinner) {
        return;
      }
      
      if (show) {
          // btn.style.pointerEvents = 'none';
          text.classList.add('hidden');
          spinner.classList.remove('hidden');
      } else {
          btn.style.pointerEvents = 'initial';
         text.classList.remove('hidden');
         spinner.classList.add('hidden');
      }
    }
  });
}
